import { IconAlertTriangleFilled } from '@calendly/ui/components/glyphs/IconAlertTriangleFilled';
import { IconBan } from '@calendly/ui/components/glyphs/IconBan';
import { IconRefresh } from '@calendly/ui/components/glyphs/IconRefresh';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorSurfaceSuccess, colorTextAction, colorTextDestructive, colorTextSecondary, colorTextWarning } from '@calendly/ui/theme';
import { cx } from '@linaria/core';
import React from 'react';
import { DISPLAY_STATUS, DisplayStatus } from 'components/meetings/utils';
const statusContainerCss = "siqt6nm";
const statusTextCss = "s14sv6i6";
const inProgressCss = "imixsw1";
const pulsingDotContainerCss = "p1d8gpc0";
const pulsingDotInnerCss = "p1amb286";
const PulsingDot: React.FC = () => <div className={pulsingDotContainerCss}>
    <div className={pulsingDotInnerCss} />
  </div>;
export interface MeetingStatusIndicatorProps {
  status: DisplayStatus;
  displayText: string;
}
interface StatusConfig {
  color: string;
  glyph?: typeof IconBan;
}
const STATUS_CONFIGS: Record<DisplayStatus, StatusConfig> = {
  CANCELLED: {
    color: colorTextDestructive,
    glyph: IconBan
  },
  IN_PROGRESS: {
    color: colorSurfaceSuccess
  },
  STARTING_SOON: {
    color: colorTextAction
  },
  UPCOMING: {
    color: colorTextAction
  },
  UP_NEXT: {
    color: colorTextAction
  },
  NO_SHOW: {
    color: colorTextWarning,
    glyph: IconAlertTriangleFilled
  },
  RESCHEDULED: {
    color: colorTextSecondary,
    glyph: IconRefresh
  }
};

/**
 * Renders a status badge for meeting time-based statuses such as
 * in-progress, starting soon, upcoming, up next, and no show.
 * Used alongside MeetingWarningIndicator.
 */
export const MeetingStatusIndicator: React.FC<MeetingStatusIndicatorProps> = ({
  status,
  displayText
}) => {
  const config = STATUS_CONFIGS[status];
  if (!config) {
    return null;
  }
  const isInProgress = status === DISPLAY_STATUS.IN_PROGRESS;
  return <div className={cx(statusContainerCss, isInProgress && inProgressCss)}>
      {isInProgress ? <PulsingDot /> : config.glyph && <UiIcon icon={config.glyph} size="small" color={config.color} />}
      <BodyText size="small" weight="semibold" color={config.color} inline>
        <div className={statusTextCss}>
          {displayText}
        </div>
      </BodyText>
    </div>;
};

require("./MeetingStatusIndicator.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingStatusIndicator.tsx");